'use client'

import Image from 'next/image'

import { useTranslations } from 'next-intl'

import { cn } from '@/utils'

import { Loader } from './loader'

type LoadingProps = {
  editPage?: boolean
  title?: string
  variant?: 'default' | 'page'
}

export const Loading: React.FC<LoadingProps> = ({
  editPage = false,
  title,
  variant = 'default'
}: LoadingProps) => {
  const tLoading = useTranslations('common.loading')
  const tComponents = useTranslations('components.loading')
  const defaultTitle = title ?? tLoading('default')
  if (editPage) {
    return (
      <>
        <div
          aria-hidden="true"
          className={cn(
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-background/80 fixed inset-0 z-50 backdrop-blur-sm',
            variant === 'page' ? 'h-screen' : 'h-auto'
          )}
        />
        <div
          aria-busy="true"
          aria-live="polite"
          className="fixed inset-0 z-50 flex items-center justify-center"
          role="status"
        >
          <div className="flex flex-col items-center gap-3">
            <Loader className="text-foreground" size="xl" />
            {defaultTitle ? (
              <div className="text-foreground text-sm font-medium">
                {defaultTitle}
              </div>
            ) : null}
          </div>
        </div>
      </>
    )
  }

  return (
    <div
      className={cn(
        'flex h-full animate-pulse flex-col items-center justify-center gap-2',
        variant === 'page' ? 'h-screen' : 'h-auto'
      )}
    >
      <Image
        alt={tComponents('alt')}
        className="h-auto w-[200px]"
        height={50}
        loading="eager"
        src="/media/logo.svg"
        width={200}
      />
      <div className="text-lg">{defaultTitle}</div>
    </div>
  )
}
